import React, { useState } from "react";
import { Button, Icon, Input, Header } from "semantic-ui-react";
export default function AddFileNameIdentifier({
  t,
  i,
  inputId,
  fileId,
  addFileNameIdentifier,
  newDataForOnSuccess,
}) {
  const [isInputOpen, setIsInputOpen] = useState(false);
  const [fileNameIdentifier, setFileNameIdentifier] = useState(
    newDataForOnSuccess[i].fileNameIdentifier
  );
  const [isDisabled, setIsDisabled] = useState(false);
  const [isDuplicated, setIsDuplicated] = useState(false);
  const validIdentifier = new RegExp(/^[a-zA-Z0-9]{3,}$/);

  const isNameDuplicated = (identifier) => {
    return newDataForOnSuccess.some((data) => data.fileNameIdentifier === identifier);
  };

  return (
    <>
      {(fileNameIdentifier.length >= 3 && !validIdentifier.test(fileNameIdentifier)) ||
      isDuplicated ? (
        <div style={{ display: "flex", gap: ".5rem", alignItems: "center", marginBottom: ".5rem" }}>
          <Header size="tiny" color="red">
            <div style={{ display: "flex" }}>
              <Icon name="warning" style={{ marginRight: "0", fontSize: ".9rem" }} />
              <p style={{ color: "#db2828", fontWeight: "normal", fontSize: ".9rem" }}>
                {t("file_name_identifier_validation_2")}
              </p>
            </div>
          </Header>
        </div>
      ) : (
        ""
      )}
      <p
        style={{
          width: "100%",
          color: "#9f3a38",
          fontWeight: "600",
          fontSize: ".78571429rem",
          lineHeight: "1em",
        }}
      >
        {!isInputOpen && fileNameIdentifier !== "" ? "" : t("file_name_identifier_mandatory_field")}
      </p>
      <div style={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
        {isInputOpen ? (
          <>
            <label htmlFor={inputId}>
              {t("file_name_identifier_label")}:
              <Input
                size="mini"
                id={inputId}
                value={fileNameIdentifier}
                placeholder={t("file_name_identifier_placeholder")}
                error={
                  (fileNameIdentifier.length >= 3 && !validIdentifier.test(fileNameIdentifier)) ||
                  isDuplicated
                }
                onChange={(e) => {
                  setFileNameIdentifier(e.target.value);
                  setIsDuplicated(isNameDuplicated(e.target.value));
                  setIsDisabled(!validIdentifier.test(e.target.value));
                }}
              />
            </label>
            <Button
              size="mini"
              basic
              style={{
                backgroundColor: "#4700a3",
                color: "white",
              }}
              onClick={() => {
                setIsInputOpen(false);
                addFileNameIdentifier(fileId, fileNameIdentifier);
              }}
              disabled={isDisabled || isDuplicated}
            >
              <Icon name="add" /> {t("file_name_identifier_add")}
            </Button>
          </>
        ) : !isInputOpen && fileNameIdentifier !== "" ? (
          <>
            <p style={{ margin: "0" }}>
              <Icon name="checkmark" color="green" />
              <strong>{t("file_name_identifier_field_name")}</strong> {fileNameIdentifier}
            </p>
            <Button
              size="mini"
              basic
              style={{
                backgroundColor: "#4700a3",
                color: "white",
              }}
              onClick={() => {
                setIsInputOpen(true);
                addFileNameIdentifier(fileId, "");
              }}
            >
              <Icon name="edit outline" />
              {t("file_name_identifier_edit")}
            </Button>
          </>
        ) : (
          <Button
            basic
            style={{
              backgroundColor: "#4700a3",
              color: "white",
            }}
            size="mini"
            onClick={() => setIsInputOpen(true)}
          >
            <Icon name="add" /> Add file name identifier
          </Button>
        )}
      </div>
    </>
  );
}
